import { Navigate, Route, Routes } from "react-router-dom";
import { Layout } from "./components/Layout";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { CallsPage } from "./pages/CallsPage";
import { GuideListPage } from "./pages/GuideListPage";
import { GuideEditorPage } from "./pages/GuideEditorPage";
import { SkillListPage } from "./pages/SkillListPage";
import { SkillEditorPage } from "./pages/SkillEditorPage";
import { TalkTrackListPage } from "./pages/TalkTrackListPage";
import { TalkTrackEditorPage } from "./pages/TalkTrackEditorPage";
import { VoiceEnginesPage } from "./pages/VoiceEnginesPage";
import { ComingSoonPage } from "./pages/ComingSoonPage";
import { EvalsPage } from "./pages/EvalsPage";
import { AppVersionsPage } from "./pages/AppVersionsPage";
import { CourseListPage } from "./pages/CourseListPage";
import { CourseEditorPage } from "./pages/CourseEditorPage";
import { MODULES } from "./modules";
import { COURSES_ENABLED } from "./config/env";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<Navigate to="/dashboard" replace />} />
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/calls" element={<CallsPage />} />
        <Route path="/companions" element={<GuideListPage />} />
        <Route path="/guides/new" element={<GuideEditorPage />} />
        <Route path="/guides/:id" element={<GuideEditorPage />} />
        <Route path="/skills" element={<SkillListPage />} />
        <Route path="/skills/new" element={<SkillEditorPage />} />
        <Route path="/skills/:id" element={<SkillEditorPage />} />
        <Route path="/talk-tracks" element={<TalkTrackListPage />} />
        <Route path="/talk-tracks/:topicId" element={<TalkTrackEditorPage />} />
        <Route path="/voice-engines" element={<VoiceEnginesPage />} />
        <Route path="/insights" element={<EvalsPage />} />
        <Route path="/app-versions" element={<AppVersionsPage />} />
        {/* Course catalog in the aura-courses Firebase project; coming-soon without its config. */}
        {COURSES_ENABLED && (
          <>
            <Route path="/courses" element={<CourseListPage />} />
            <Route path="/courses/new" element={<CourseEditorPage />} />
            <Route path="/courses/:id" element={<CourseEditorPage />} />
          </>
        )}
        {MODULES.filter((m) => m.comingSoon).map((m) => (
          <Route key={m.key} path={m.path} element={<ComingSoonPage module={m} />} />
        ))}
        {/* Legacy coming-soon paths now served by real pages. */}
        <Route path="/analytics" element={<Navigate to="/dashboard" replace />} />
        <Route path="/recordings" element={<Navigate to="/calls" replace />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Route>
    </Routes>
  );
}
